import { XStack, YStack } from '@/components/ui/layout/layout';
import { Skeleton } from '@/components/ui/skeleton';
import { SettingsSection } from '@/features/settings/settings-section';

export function TeamDashboardSkeleton() {
  return (
    <SettingsSection.Root>
      <SettingsSection.Header>
        <Skeleton className="h-7 w-28" />
      </SettingsSection.Header>

      <YStack className="gap-3">
        <XStack className="items-center justify-between gap-3">
          <Skeleton className="h-9 w-64" />
          <Skeleton className="h-8 w-20" />
        </XStack>
        <YStack className="gap-0 max-h-[calc(100dvh-16rem)] rounded-xl border border-border dark:border-border-strong overflow-hidden">
          <Skeleton className="h-10 w-full rounded-none" />
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton
              key={i}
              className="h-14 w-full rounded-none border-t border-border"
            />
          ))}
        </YStack>
      </YStack>
    </SettingsSection.Root>
  );
}
